import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AsmAuthStorageService, CsAgentAuthService } from '@spartacus/asm/root';
import {
  AuthService,
  AuthStorageService,
  CmsNavigationComponent,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
} from '@spartacus/core';
// tslint:disable-next-line: max-line-length
import {
  BREAKPOINT,
  BreakpointService,
  CmsComponentData,
  NavigationNode,
  NavigationService,
  SiteContextType,
} from '@spartacus/storefront';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { concatMap, map, switchMap, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { LanguageExtendService } from 'src/app/service/language/language-extend.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { PermissionsConstants } from 'src/app/service/myaccount/my-account-permission.constants';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import {
  COUNTRY_FLAG_INSTEAD,
  FLAG_ICON,
  MyaccountFeaturesConfigService,
} from 'src/app/service/myaccount/myaccount-features-config.service';
import { OrderHistoryService } from 'src/app/service/orders/order-history.service';
import { PaymentService } from 'src/app/service/payment/payment.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { LogoutService } from 'src/app/service/user/logout.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../asm/asm-constant';
import { MyAccountMobileComponent } from './my-account-mobile/my-account-mobile.component';

export interface MyAccountMobileDialogData {
  myAccountMobileNavNode: any[];
  activeLanguageIsocode: string;
  activeLanguageName: string;
  activeLanguageCountryIsocode: string;
  languageMobileNavNode: any[];
}

export interface NavRestrictionsModel {
  url: string[];
  styleClasses: string[];
}

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MyAccountComponent implements OnInit, OnDestroy {
  headerLinksNavNode$: Observable<NavigationNode>;
  headerLinksPositionId = 'HeaderLinks';
  myAccountLinksPositionId = 'MyAccount';
  myAccountLinks: any[];
  globalMsg = document.querySelector('cx-global-message');
  isTablet = false;
  isMobile = false;
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);
  csTabletWidth = this.breakpointService.getSize(BREAKPOINT.sm);
  showMyAccountDropdown = false;
  headerLinksNavNode: any;
  activeI: number;
  showSubSubMenu: boolean[] = [];
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  occBaseUrl = `${this.occUrl.content}`;
  baseUrl = this.occBaseUrl;
  activeLanguage: string;
  activeLanguageData$: any;
  activeLanguageIsocode: string;
  activeLanguageCountryIsocode: string;
  activeLanguageName: string;
  shimanoActiveLanguageData: any;

  myAccountMobileNavNode: any[] = [];
  headerLinksMobileNavEntries: any[] = [];
  languageMobileNavNode: any[] = [];
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  @Input() myAccountNavNode: any;
  @Input() context: SiteContextType;
  myAccountNavNodeOverride: any;
  myAccountLinksOverride: any[];
  globalNavMobileSubscription$: Subscription;
  availableLanguagesSubscription$: Subscription;
  myAccountLinksSubscription$: Subscription;
  breakpointSubscription$: Subscription;

  activeCountry$: Observable<string> = this.countryService.getActive();

  isLanguageFlagIconEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, FLAG_ICON)
    )
  );

  isCountryFlagInsteadEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, COUNTRY_FLAG_INSTEAD)
    )
  );

  @HostListener('window:resize')
  onResize(): void {
    this.closeMyAccountDropdown();
  }

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private service: NavigationService,
    private router: Router,
    private breakpointService: BreakpointService,
    private cmsService: CmsService,
    private languageService: ShimanoLanguageService,
    private languageExtendService: LanguageExtendService,
    private meta: Meta,
    private dialog: MatDialog,
    protected routingService: RoutingService,
    protected authService: AuthService,
    protected authStorageService: AuthStorageService,
    protected asmAuthStorageService: AsmAuthStorageService,
    protected asmAuthService: CsAgentAuthService,
    private orderHistoryService: OrderHistoryService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private countryService: ShimanoCountryService,
    private myaccountFeaturesConfigSerivce: MyaccountFeaturesConfigService,
    private storageService: StorageService,
    private logoutService: LogoutService,
    private myAccountPermissionService: MyAccountPermissionService,
    private paymentService: PaymentService,
    private globalMessageService: GlobalMessageService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.breakpointSubscription$ = this.breakpointService.breakpoint$.subscribe((breakpoint) => {
      this.isTablet = breakpoint === BREAKPOINT.lg;
      this.isMobile = breakpoint === BREAKPOINT.sm || breakpoint === BREAKPOINT.md;
      this.getHeaderLinksNavNodeAndLanguageItems(true);
    });

    this.globalNavMobileSubscription$ = this.componentService.isGlobalNavMobileMenuOpen$.subscribe(
      (isGloblNavMobileMenuOpen) => {
        if (this.showMyAccountDropdown && isGloblNavMobileMenuOpen) {
          this.closeMyAccountDropdown();
        }
        this.cdr.detectChanges();
      }
    );
  }

  get myAccountNavNode$(): Observable<NavigationNode> {
    return this.service.getNavigationNode(this.componentData.data$);
  }

  onClick(goToUrl: string, styleClasses: string) {
    if (goToUrl.includes('asm=false') && this.asmEnabled) {
      this.authStorageService
        .getToken()
        .pipe(take(1))
        .subscribe((token) => {
          if (this.asmAuthStorageService.getTokenTarget()) {
            const showSrp = this.storageService.getLocalStorageItem('showSrp');
            this.storageService.clearLocalStorageItem();
            this.storageService.setLocalStorageitem(ASM_ENABLED_LOCAL_STORAGE_KEY, 'true');
            this.storageService.setLocalStorageitem('showSrp', showSrp);
            this.storageService.setSessionStorageItem('showSrp', showSrp); //add showSRP in sessionStorage
            this.logoutService.logout();
            this.router.navigate(['login'], { queryParams: { asm: 'true' } });
          }
          this.asmAuthService.logoutCustomerSupportAgent();
        });
    } else {
      if (goToUrl.includes('/logout')) {
        // this.logoutService.logout();
        this.authService.coreLogout().finally(() => {
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
          this.router.navigate(['login']);
          window.location.reload();
        });
      } else if (styleClasses !== undefined) {
        this.styleClassesCheck(styleClasses);
      } else {
        this.router.navigateByUrl(goToUrl);
      }
      this.cmsService
        .getCurrentPage()
        .pipe(
          take(1),
          map((page) => page.label)
        )
        .subscribe((pageLabel: string) => {
          if (goToUrl.includes('orders')) {
            this.orderHistoryService.refreshOrders(true, pageLabel === '/orders');
          }
        });
    }
  }

  styleClassesCheck(className: string) {
    switch (className) {
      case 'snappayInvoicesLink':
        this.onRedirectToSnappayInvoice();
        break;
      // add new class here
      default:
        break;
    }
  }
  onRedirectToSnappayInvoice() {
    this.paymentService
      .redirectToSnappayInvoice()
      .pipe(take(1))
      .subscribe({
        next: (invoiceData) => {
          this.paymentService.fullPageOverlaySpinner('hide');
        },
        error: (err) => {
          this.paymentService.fullPageOverlaySpinner('hide');
          setTimeout(() => {
            if (this.globalMsg) {
              this.renderer.addClass(this.globalMsg, 'showCxGlobalMessage');
              this.globalMessageService.add({ key: 'error.snappaySsoToken' }, GlobalMessageType.MSG_TYPE_ERROR);
            }
          });
        },
      });
  }

  onClickMyAccountDropdown($event: any) {
    $event.stopPropagation();
    this.showMyAccountDropdown ? (this.showMyAccountDropdown = false) : (this.showMyAccountDropdown = true);
    this.componentService.setIsMyAccountMenuOpen(this.showMyAccountDropdown);
  }

  closeMyAccountDropdown() {
    if (this.showMyAccountDropdown) {
      this.showMyAccountDropdown = false;
      this.componentService.setIsMyAccountMenuOpen(false);
    }
  }

  onShowMyAccountMobileDialogRef(): void {
    const dialogRef = this.dialog.open(MyAccountMobileComponent, {
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'my-account-mobile-dialog',
      hasBackdrop: true,
      data: {
        myAccountMobileNavNode: this.myAccountMobileNavNode,
        activeLanguageIsocode: this.activeLanguageIsocode,
        activeLanguageName: this.activeLanguageName,
        activeLanguageCountryIsocode: this.activeLanguageCountryIsocode,
        languageMobileNavNode: this.languageMobileNavNode,
      },
    });
    dialogRef.afterClosed().subscribe((afterClosedData: any) => {
      this.getAvailableLanguages();
      this.getShimanoActiveLanguage();
    });
  }

  getHeaderLinksNavNodeAndLanguageItems(fromLogin = false) {
    this.getHeaderLinks();
    this.getMyAccountLinks();
    if ((this.isMobile || this.isTablet) && fromLogin) {
      this.getLanguageItems();
    } else {
      this.getAvailableLanguages();
    }
  }

  getLanguageItems() {
    this.getAvailableLanguages();
    const selectedLanguageOnLogin = this.storageService.getLocalStorageItem('selectedLanguageOnLogin');
    const asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
    if (selectedLanguageOnLogin && !asmEnabled) {
      this.setShimanoActiveLanguage(selectedLanguageOnLogin, true);
    } else {
      this.getShimanoActiveLanguage();
    }
  }

  getHeaderLinks() {
    this.cmsService
      .getContentSlot(this.headerLinksPositionId)
      .pipe(take(1))
      .subscribe((pos) => {
        const headerUid = pos.components[0].uid;
        this.cmsService
          .getComponentData(headerUid)
          .pipe(take(1))
          .subscribe((headerLinks: any) => {
            this.headerLinksMobileNavEntries = [...headerLinks['navigationNode'].entries];
          });
      });
  }

  getMyAccountLinks() {
    this.cmsService
      .getContentSlot(this.myAccountLinksPositionId)
      .pipe(take(1))
      .subscribe((pos) => {
        const accountUid = pos.components[0].uid;
        this.myAccountLinksSubscription$ = this.cmsService
          .getComponentData(accountUid)
          .pipe(
            switchMap((componentData) =>
              combineLatest([this.service.getNavigationNode(of(componentData)), this.getNavRestrictions()])
            )
          )
          .subscribe(([myAccountLinks, restrictions]) => {
            //for desktop
            this.myAccountNavNodeOverride = restrictions
              ? this.myAccountNavOverride(restrictions, { ...this.myAccountNavNode })
              : null;
            //for tablet
            this.myAccountLinks = [myAccountLinks];
            this.myAccountLinksOverride = restrictions
              ? [this.myAccountNavOverride(restrictions, { ...myAccountLinks })]
              : null;
          });
      });
  }

  getAvailableLanguages() {
    this.availableLanguagesSubscription$ = this.languageExtendService
      .getAvailableLanguages()
      .pipe(map((res) => res.languages))
      .subscribe((data) => {
        const languageItems = { title: 'Languages', children: data };
        this.languageMobileNavNode = [languageItems];
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      });
  }

  setShimanoActiveLanguage(language: string, fromLogin = false) {
    this.languageExtendService
      .setShimanoActiveLanguage(language)
      .pipe(
        take(1),
        concatMap(() => {
          this.languageService.setActive(language);
          return this.languageExtendService.getShimanoActiveLanguage();
        })
      )
      .subscribe((activeLanguage) => {
        this.shimanoActiveLanguageData = activeLanguage.language;
        this.activeLanguageName = activeLanguage.language.name;
        this.activeLanguageCountryIsocode = activeLanguage.language.country.isocode;
        this.activeLanguageIsocode = activeLanguage.language.isocode;
        this.getHeaderLinksNavNodeAndLanguageItems();
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
        if (fromLogin) {
          this.storageService.removeLocalStorageItem('selectedLanguageOnLogin');
          this.componentService.isPageLoadedFromLogin$.next(true);
          window.location.reload();
        }
      });
  }

  getShimanoActiveLanguage() {
    this.languageExtendService
      .getShimanoActiveLanguage()
      .pipe(take(1))
      .subscribe((activeLanguage) => {
        this.languageService.setActive(activeLanguage.language.isocode);
        this.shimanoActiveLanguageData = activeLanguage.language;
        this.activeLanguageName = activeLanguage.language.name;
        this.activeLanguageCountryIsocode = activeLanguage.language.country.isocode;
        this.activeLanguageIsocode = activeLanguage.language.isocode;
        this.getHeaderLinksNavNodeAndLanguageItems();
      });
  }

  onClickSubMenu($event: any, index: number) {
    $event.stopPropagation();
    if (this.showSubSubMenu[index]) {
      this.showSubSubMenu[index] = false;
    } else {
      this.showSubSubMenu[index] = true;
    }
  }

  getNavRestrictions(): Observable<NavRestrictionsModel> {
    return this.myAccountPermissionService.currentUserPermissions$.pipe(
      map((permissions: any) => {
        if (permissions) {
          let restrictions: NavRestrictionsModel = { url: [], styleClasses: [] };
          // add additional My Account Nav Restrictions here
          if (!permissions.includes(PermissionsConstants.VIEW_ORDER_HISTORY)) {
            restrictions.url.push(PermissionsConstants.ORDER_HISTORY_PAGE_ID);
          }
          if (!permissions.includes(PermissionsConstants.VIEW_AND_PAY_INVOICES)) {
            restrictions.styleClasses.push(PermissionsConstants.SNAPPAY_INVOICE_STYLECLASSES);
          }
          return restrictions;
        }
      })
    );
  }

  myAccountNavOverride(restrictions: NavRestrictionsModel, nav: any): any {
    let newNav = JSON.parse(JSON.stringify(nav));
    restrictions.url.forEach((url: string) => {
      // remove from My Account Nav
      const index = newNav.children.map((nav: any) => nav.url).indexOf(url);
      if (index > -1) newNav.children.splice(index, 1);
    });
    restrictions.styleClasses.forEach((styleClasses: string) => {
      // remove from My Account Nav
      const index = newNav.children.map((nav: any) => nav.styleClasses).indexOf(styleClasses);
      if (index > -1) newNav.children.splice(index, 1);
    });
    return newNav;
  }

  ngOnDestroy() {
    if (this.myAccountLinksSubscription$) {
      this.myAccountLinksSubscription$.unsubscribe();
    }
    if (this.availableLanguagesSubscription$) {
      this.availableLanguagesSubscription$.unsubscribe();
    }
    if (this.globalNavMobileSubscription$) {
      this.globalNavMobileSubscription$.unsubscribe();
    }
    if (this.breakpointSubscription$) {
      this.breakpointSubscription$.unsubscribe();
    }
  }
}
